import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
type Testimonial = {
  initials: string;
  name: string;
  city: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Martina G.',
  city: 'Rosario',
  quote: 'Venía operando hace dos años sin estructura ninguna. Con el módulo 1 empecé a entender por qué tomaba las decisiones que tomaba. Eso solo ya cambió todo.'
}, {
  initials: 'LF',
  name: 'Lucas F.',
  city: 'Córdoba',
  quote: 'No esperaba que algo tan simple como el Framework de revisión me ayudara a no perder el hilo en medio de una jornada. Lo apliqué desde el primer día.'
}, {
  initials: 'VR',
  name: 'Valentina R.',
  city: 'Santa Fe',
  quote: 'Leí la primera estrategia y la entendí al toque. La puse en práctica con papel y lápiz antes de usar dinero real.'
}, {
  initials: 'EM',
  name: 'Ezequiel M.',
  city: 'Tucumán',
  quote: 'Lo que más me gustó es que no te venden magia. Te dan estructura y te hacen pensar.'
}, {
  initials: 'NB',
  name: 'Natalia B.',
  city: 'Mar del Plata',
  quote: 'Hice el backtesting de la segunda estrategia como sugieren y fue muy revelador. Te obliga a ser honesto con vos mismo.'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-223" data-mp="c73phbmtpmiz">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand text-brand" data-id="element-224" data-mp="zyscqdksfkt2" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-225" data-mp="q7ejgnjfjh8d">
      <Reveal data-id="element-226" data-mp="q4s9yiczarni">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-227" data-mp="v5g071tdv4go">
          Personas que ya empezaron el camino
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-228" data-mp="1nm0kd25ov5y9">
        {testimonials.map((t, i) => <Reveal key={t.initials} delay={i * 0.05} className={i === testimonials.length - 1 ? 'sm:col-span-2' : ''} data-id="element-229" data-mp="1xi0lr5tr9nwj" data-mpi={i}>
            <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-230" data-mp="1sjpd2yf75jfw">
              <div className="flex items-center gap-3" data-id="element-231" data-mp="1ofhqb6saudkb">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border border-brand/30 bg-brand-soft font-display text-sm font-bold text-brand" data-id="element-232" data-mp="1jj0ya1hzbf1y">
                  {t.initials}
                </span>
                <div data-id="element-233" data-mp="19r3lwrf8ih1n">
                  <figcaption className="text-sm font-semibold text-white" data-id="element-234" data-mp="19qlgp5algshl">
                    {t.name}
                  </figcaption>
                  <p className="text-xs text-gray-500" data-id="element-235" data-mp="10sj9u946j5me">{t.city}</p>
                </div>
                <div className="ml-auto" data-id="element-236" data-mp="vt6ojssyi6lx">
                  <Stars data-id="element-237" data-mp="vs40dsn0qi9p" />
                </div>
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-gray-300" data-id="element-238" data-mp="qtakjtk9ef6d">
                “{t.quote}”
              </blockquote>
            </figure>
          </Reveal>)}
      </div>
    </Section>;
}